import { useState } from 'react';
import './NewsletterBox.css';

export function NewsletterBox() {
  const [email, setEmail] = useState('');
  const [state, setState] = useState<'idle' | 'sending' | 'ok' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setState('sending');
    setErrorMsg(null);
    try {
      const res = await fetch(`${import.meta.env.VITE_API_URL}/public/newsletter/subscribe`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ email, locale: 'ar' }),
      });
      if (!res.ok) {
        setState('error');
        setErrorMsg('فشل — تأكدوا من البريد الإلكتروني');
        return;
      }
      setState('ok');
      setEmail('');
    } catch {
      setState('error');
      setErrorMsg('الشبكة غير متاحة');
    }
  }

  return (
    <div className="ts-newsletter-box mt-4">
      <h5 className="title">النشرة الإخبارية</h5>
      <p>اشتركوا الآن لتصلكم آخر الأخبار والمستجدات.</p>
      <form onSubmit={onSubmit} className="ts-newsletter-input">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="البريد الإلكتروني"
        />
        <button type="submit" disabled={state === 'sending'}>
          {state === 'sending' ? '...' : 'اشتراك'}
        </button>
      </form>
      {state === 'ok' && <span className="ts-newsletter-msg ok">شكرًا، تم تأكيد اشتراككم.</span>}
      {state === 'error' && errorMsg && (
        <span className="ts-newsletter-msg err">{errorMsg}</span>
      )}
      {state !== 'ok' && state !== 'error' && (
        <span className="ts-newsletter-msg">بعد الاشتراك ستصلكم رسالة تأكيد.</span>
      )}
    </div>
  );
}
